module.exports = __webpack_public_path__ + "static/media/404.fea32df0.svg";